import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';

import { createAction } from 'utils';

import './AdjustRemarkTextarea.scss';

const AdjustRemarkTextarea = ({
  remarks,
  setRemarks,
  remarkTemplates = [],
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(createAction('settings/getAllRemarkTemplates')());
  }, []);

  return (
    <div className="adjust-remark">
      <textarea
        className="adjust-remark-textarea"
        rows="4"
        placeholder="Please input"
        value={remarks}
        onChange={({ target }) => {
          const { value } = target;
          setRemarks(value);
        }}
      />
      <div className="adjust-remark-templates">
        {remarkTemplates?.map((template) => {
          const optionName = template.name;
          return (
            <Button
              className="adjust-remark-template"
              variant="light"
              size="sm"
              onClick={() => setRemarks(`${remarks}${optionName}`)}
            >
              {optionName}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

const mapPropsToState = (state) => ({
  remarkTemplates: state.settings.remarkTemplates,
});

export default connect(mapPropsToState)(AdjustRemarkTextarea);
